import Pro1 from "../Projects/carz-1.png";
import Pro2 from "../Projects/electro1.png";
import Pro3 from "../Projects/gym1.png";
import ProMybook from "../Projects/mybook.png";
import ProAbnb from "../Projects/airbnb.png";
import ProGreeplanet from "../Projects/green-planet.png";
import ProJll from "../Projects/Jll.png";
import Foodish from "../Projects/foodish.png";
import Tour from "../Projects/tour.png";
import Homiq from "../Projects/homiq.png";
import Zafran from "../Projects/zafran.png";
import Knect from "../Projects/knect.png";
import Fluentoo from "../Projects/fluentoo.png";
import Tryesy from "../Projects/tryesy.png";
import Lookup from "../Projects/lookup.png";
import Savor from "../Projects/savor.png";
import Collabify from "../Projects/collabify.png";
import Decoor from "../Projects/decoor.png";
import Wallet from "../Projects/wallet.png";
import Nastech from "../Projects/nastech.png";
import NovaEv from "../Projects/novaEv.png";
import Soltra from "../Projects/soltra.png";
import Solar from "../Projects/solar.png";
import Infra from "../Projects/infra.png";
import Wanderly from "../Projects/wanderly.png";
import Jetlore from "../Projects/jetlore.png";
import Travel from "../Projects/travel.png";
import Micron from "../Projects/micron.png";
import TenantFinance from "../Projects/tenantFinance.png";
import Lavea from "../Projects/lavea.png";
import Inovo from "../Projects/inovo.png";
import CarRide from "../Projects/carRide.png";
import Portfolio from "../Projects/portfolio.png";
import DesignCon from "../Projects/designCon.png";
import ViceHome from "../Projects/viceHome.png";
import Xoomanage from "../Projects/xoomanage.png";
import Mynztrip from "../Projects/mynztrip.png";
import GrandPool from "../Projects/grandPool.png";
import FreightMind from "../Projects/freightMind.png";
import SocioMeet from "../Projects/socioMeet.png";
import Revvo from "../Projects/revvo.png";
import Influview from "../Projects/influview.png";
import Dooarch from "../Projects/dooarch.png";
import Lucrate from "../Projects/lucrate.png";
import Quirk from "../Projects/quirk.png";
import IeltsManager from "../Projects/ieltsmanager.png";
import Rozer from "../Projects/Rozer.png";
import PayPilot from "../Projects/PayPilot.png";
import WioCare from "../Projects/Wiocare.png";
import Sneaks from "../Projects/Sneaks.png";

export const ProjectsData = [
  {
    id: 17,
    title: "PrepDesk",
    category: "uiux",
    description:
      "PrepDesk- A IELTS agency manage multi-tenant SaaS Product. Deshi IELTS Coaching agencyies struggle to manage their student, teach...",
    img: IeltsManager,
    // dribble:
    //   "https://dribbble.com/shots/26725379-Business-Management-SAAS-Landing-Page",
    liveLink:
      "https://www.figma.com/design/Sp1WueWAnP18cUrzYk2Gin/PrepDesk?node-id=0-1&t=7y4hFlb1YBQqSZ50-1",
  },
  {
    id: 2,
    title: "Rozer",
    category: "uiux",
    description:
      "Designed the core employee daily attendence for the HR platform, focusing on a clean, modern, and intuitive experience across four key screens - Global Sidebar Navigation, Main Dashboard, Attendance Log, and Leave Management.",
    img: Rozer,
    liveLink:
      "https://www.figma.com/design/erwCC2ck3wUykbgSDoVdg4/Rozer?node-id=51-916&t=YvWRJgrtOUzMwTdB-1",
  },
  {
    id: 2,
    title: "Quirk",
    category: "uiux",
    description:
      "Designed an SMM Platform landing page with a purpose. Not just another landing page — a structured flow built to guide visitors from curiosity to conversion. Clear value props, real social proof, and a frictionless path to action.",
    img: Quirk,
    liveLink:
      "https://www.figma.com/design/FhS0s1NHxjKv7Cwhztp37N/Quirk?node-id=0-1&t=mrYq6yvZnwpddw9C-1",
  },
  {
    id: 2,
    title: "WioCare",
    category: "uiux",
    description:
      "I redesigned the homepage of Wio care's website and designed a companion mobile app, focused on a modern, clean look that's easy to use and feels trustworthy.",
    img: WioCare,
    liveLink:
      "https://www.figma.com/design/Al49drWYOk7btRXgyfIHk4/WioCare?node-id=12-313&t=bCjZD4uEphwL4suu-1",
  },
  {
    id: 17,
    title: "Wallet",
    category: "uiux",
    description:
      "Wallet- A Finance SAAS landing page. Toward Your Business- Manage Budgets, Forecast Cash Flow, and Optimize Every Dollar with Wallet.",
    img: Wallet,
    dribble:
      "https://dribbble.com/shots/26725379-Business-Management-SAAS-Landing-Page",
    liveLink:
      "https://www.figma.com/design/tlyboiydPCVWlQ6q7svy2M/wallet---finance-SAAS-landing-page?node-id=13-90&t=2L8gQOzr2dstxL2U-1",
  },

  {
    id: 18,
    title: "Grand Pool",
    category: "uiux",
    description:
      "Design a website homepage for Grand Pools, a luxury residential pool builder based in Melbour... ",
    img: GrandPool,
    //  dribble:
    //    "https://dribbble.com/shots/26845586-NovaEV-Electrify-Your-Journey",
    liveLink:
      "https://www.figma.com/design/tEMzeOVWCciWv3x37HZvSF/GrandPool?node-id=0-1&t=Op9KvEuCC9it2cD9-1",
  },
  {
    id: 18,
    title: "Mynztrip",
    category: "uiux",
    description:
      "I've redesign mynztrip homepage for convert more lead and increase Business. It was my personal design explora..",
    img: Mynztrip,
    //  dribble:
    //    "https://dribbble.com/shots/26845586-NovaEV-Electrify-Your-Journey",
    liveLink:
      "https://www.figma.com/design/jHJ48TrbKfvQpI9eXamDll/Untitled?node-id=0-1&t=sqDjhQa47KtB8mex-1",
  },
  {
    id: 18,
    title: "Lucrate",
    category: "uiux",
    description:
      "Lucrate is a beauty and fashion brand for women, design with high regulation images, bold typography, modern lay...",
    img: Lucrate,
    //  dribble:
    //    "https://dribbble.com/shots/26845586-NovaEV-Electrify-Your-Journey",
    liveLink:
      "https://www.figma.com/design/NJq82u91NJX5AfA3OvBjlW/Untitled?node-id=11-120&t=o2ycbJkw1DsAhejN-1",
  },
  {
    id: 1,
    title: "DooArch",
    category: "uiux",
    description:
      "A website design for an architecture studio. Clean layout, bold headlines, simple words. Built with Bold typography, clean, minimal, modern layout.",
    img: Dooarch,
    liveLink:
      "https://www.figma.com/design/Qpb0fRSDCdZYmM8I0Bn2jf/DOOARCH?node-id=16-147&t=pTgBBeukyxmv3Url-1",
  },

  {
    id: 2,
    title: "Influview",
    category: "uiux",
    description:
      "Designed a futuristic website for an AR/VR technology company, built to reflect the brand's core promise — breaking the boundaries of physical reality",
    img: Influview,
    liveLink:
      "https://www.figma.com/design/I982KB9r5hz0k612LDZ7aO/Untitled?node-id=0-1&t=mDJxURcYXBbUmAWH-1",
  },
  {
    id: 17,
    title: "Jetlore",
    category: "uiux",
    description:
      "Jetlore is flight booking application home page with modern, minimalise design concept",
    img: Jetlore,
    //  dribble:
    //    "https://dribbble.com/shots/26725379-Business-Management-SAAS-Landing-Page",
    liveLink:
      "https://www.figma.com/design/uPbCh79kSUPOPGPmSCFcFd/Jetlore?t=6t42XcaoYmYPyhfB-1",
  },
  {
    id: 18,
    title: "De Lavèa",
    category: "uiux",
    description:
      "De Lavèa- Premium perfume selling website I designed. My goal was to make it looking simple, minimalis...",
    img: Lavea,
    //  dribble:
    //    "https://dribbble.com/shots/26845586-NovaEV-Electrify-Your-Journey",
    liveLink:
      "https://www.figma.com/design/JfXerDGCY87kVO4FWhRexy/De-Lavea?node-id=0-1&t=ajJK5AocLWNGERa5-1",
  },

  {
    id: 1,
    title: "Foodish ",
    category: "uiux",
    description:
      " Order your favourite Foods with Foodish from top restaurants, track your order in real time, and enjoy tasty ...",
    img: Foodish,
    doc: "https://www.notion.so/Food-Delivery-app-274448e894188009b473d27388245bd0?source=copy_link",
    dribble:
      "https://dribbble.com/shots/26723882-Foodish-App-UI-Design-Simplifying-Food-Ordering",
    liveLink:
      "https://www.figma.com/design/4V0pyMCC1hVvtyzmfz1SGC/Foodish---Food-delivery-app?t=Op9KvEuCC9it2cD9-1",
  },
  {
    id: 1,
    title: "PayPilot ",
    category: "uiux",
    description:
      "Freelancer, small business owner, solo founder, struggle to manage their finances mainly income, expances, bills etc. That's where Paypilot comes and solve their problems and provide one-place hands-on solutions.",
    img: PayPilot,
    liveLink:
      "https://www.figma.com/design/EteVgZtAMZ52tP4nxtSUC8/PayPilot?node-id=4-566&t=bCjZD4uEphwL4suu-1",
  },
  {
    id: 2,
    title: "Homiq",
    category: "uiux",
    description:
      "User can get any home service at their doorstep with Homiq. Fast, reliable and hassle-free...",
    img: Homiq,
    doc: "https://www.notion.so/Service-Marketplace-App-250448e8941880f2ad97e9950510c16c?source=copy_link",
    liveLink:
      "https://www.figma.com/design/k58UAk8sQ4uB9T1k2rw2Hl/Homiq---Service-marketplace?node-id=71-376&t=wV1PG0eRMJFEOSvd-1",
  },

  {
    id: 18,
    title: "Innovo",
    category: "uiux",
    description:
      "Inovo is innovation, and development company website. There primary work with innovation and developme..",
    img: Inovo,
    //  dribble:
    //    "https://dribbble.com/shots/26845586-NovaEV-Electrify-Your-Journey",
    liveLink:
      "https://www.figma.com/design/P3KtSuHaIeEfZ3S0Lwye5t/Innovo?t=ajJK5AocLWNGERa5-1",
  },

  {
    id: 1,
    title: "Revvo",
    category: "uiux",
    description:
      "Revvo is a Creative Design Agency Protfolio Website design with bold typography, brutal color, catchy ima...",
    img: Revvo,
    // dribble:
    //   "https://dribbble.com/shots/26725379-Business-Management-SAAS-Landing-Page",
    liveLink:
      "https://www.figma.com/design/SIYOLK0pTCZAARgeXPtJLk/Untitled?node-id=0-1&t=nf9GgfJcr8q1l2EZ-1",
  },

  {
    id: 3,
    title: "Sneeks",
    category: "uiux",
    description:
      "Sneaks is a modern sneaker e-commerce platform with a focus on user experience and seamless shopping.",
    img: Sneaks,
    liveLink:
      "https://www.figma.com/design/4Uq3HHoNHNdQUgJOEVD3G3/Sneeks---Ecommerce?node-id=73-3044&t=YvWRJgrtOUzMwTdB-1",
  },
  {
    id: 3,
    title: "Zafran",
    category: "uiux",
    description:
      "Zafran is a complete online shopping experience including prodcut pages, cart, checkout and payment flow.",
    img: Zafran,
    dribble:
      "https://dribbble.com/shots/26720554-E-commerce-Web-Application-UI-Design",
    liveLink:
      "https://www.figma.com/design/llhe3JqEt69V07MDnU8SY5/Zafran?node-id=0-1&t=rMNIXitYnkqVEW44-1",
  },
  {
    id: 17,
    title: "Micron",
    category: "uiux",
    description:
      "A Business growth and management SAAS platform for startup to Enterprise business owner. Micron- Your Business's Best Friend: Streamline Operations, Boost Productivity, and Achieve Success with Micron.",
    img: Micron,
    //  dribble:
    //    "https://dribbble.com/shots/26725379-Business-Management-SAAS-Landing-Page",
    liveLink:
      "https://www.figma.com/design/2fJehJkD3shxFv5I4BLoIr/Untitled?node-id=0-1&t=zxSANAkdpPDRECIq-1",
  },

  {
    id: 18,
    title: "Freight Mind",
    category: "uiux",
    description:
      "Freigt Mind is a website for Freight service proving company globally with A... ",
    img: FreightMind,
    //  dribble:
    //    "https://dribbble.com/shots/26845586-NovaEV-Electrify-Your-Journey",
    liveLink:
      "https://www.figma.com/design/MKyEOno4ZuOtNTuOyKCKEq/FreightMind-AI?t=Op9KvEuCC9it2cD9-1",
  },

  {
    id: 2,
    title: "Tenant Finance",
    category: "uiux",
    description:
      "Tenant Finance is Finance and Fund providing Company for SME, Enterprise comany, their main...",
    img: TenantFinance,
    liveLink:
      "https://www.figma.com/design/M8mfydtkc9VYCxSIBMycdF/TenantFinance?node-id=0-1&t=jyXsB0QhnbdiUcG4-1",
  },
  {
    id: 18,
    title: "Xoomanage",
    category: "uiux",
    description:
      "Design a product for a multi-vendor e-commerce system.manage products & inventory, handle POS...",
    img: Xoomanage,
    //  dribble:
    //    "https://dribbble.com/shots/26845586-NovaEV-Electrify-Your-Journey",
    liveLink:
      "https://www.figma.com/design/Egcl4KGIkUzdjSs0azl6Jd/Untitled?node-id=17-816&t=8j3YvdExNTE4O6eV-1",
  },

  {
    id: 18,
    title: "DesignConf",
    category: "uiux",
    description:
      "Design a conferences ticket booking website with bold, informative an...",
    img: DesignCon,
    //  dribble:
    //    "https://dribbble.com/shots/26845586-NovaEV-Electrify-Your-Journey",
    liveLink:
      "https://www.figma.com/design/tpDdHdcG0HCYBKqhkCK04K/DesignConf?node-id=0-1&t=ajJK5AocLWNGERa5-1",
  },

  {
    id: 18,
    title: "GoRide",
    category: "uiux",
    description:
      "GoRide mission was simple- make booking car simple for Airport drop and pickup, City Ride, Hourly car boo... ",
    img: CarRide,
    //  dribble:
    //    "https://dribbble.com/shots/26845586-NovaEV-Electrify-Your-Journey",
    liveLink:
      "https://www.figma.com/design/vTvafQbqzeZPcGPMZiBl1Q/GoRide?node-id=6-63&t=ajJK5AocLWNGERa5-1",
  },
  {
    id: 18,
    title: "Designer Portfolio",
    category: "uiux",
    description:
      "Design a website for Senior Product Designer, Alex. With Bold, Trendy design concept, emphathise on detai...",
    img: Portfolio,
    //  dribble:
    //    "https://dribbble.com/shots/26845586-NovaEV-Electrify-Your-Journey",
    liveLink:
      "https://www.figma.com/design/BQWY8S011WUenkyrKuISzo/Alex-Portfolio?t=ajJK5AocLWNGERa5-1",
  },

  {
    id: 18,
    title: "ViceHome",
    category: "uiux",
    description:
      "ViceHome is Home Services Provide Website Homepage. Here implemented there services, how they work..",
    img: ViceHome,
    //  dribble:
    //    "https://dribbble.com/shots/26845586-NovaEV-Electrify-Your-Journey",
    liveLink:
      "https://www.figma.com/design/g0Lpj53IRdM9rTbb9WUTNZ/ViceHome?t=ajJK5AocLWNGERa5-1",
  },

  {
    id: 18,
    title: "Travel",
    category: "uiux",
    description:
      "Travel- makes traveling easy and comfortable. Travel design for convenient easy navigation tour and exploring the world more organised way",
    img: Travel,
    //  dribble:
    //    "https://dribbble.com/shots/26845586-NovaEV-Electrify-Your-Journey",
    liveLink:
      "https://www.figma.com/design/CFijZv54OlMfpd9eS7CQvs/Travel--travel-agency-landing-page?t=6t42XcaoYmYPyhfB-1",
  },

  {
    id: 18,
    title: "NovaEV",
    category: "uiux",
    description:
      "NovaEV is a modern and minimal EV landing page crafted to showcase the future of electric mobility. With strong hero visuals, smooth sections, and clear CTAs, it aims to captivate visitors and drive conversions.",
    img: NovaEv,
    dribble:
      "https://dribbble.com/shots/26845586-NovaEV-Electrify-Your-Journey",
    liveLink:
      "https://www.figma.com/design/YU3IACj1cYANPug9iARJlw/NovaEV--Electric-car-landing-page?node-id=0-1&t=pZJO5gMzjc296l0j-1",
  },
  {
    id: 20,
    title: "Wanderly",
    category: "uiux",
    description:
      "Wanderly is a travel planning app that helps users discover new destinations, create itineraries, and share their travel experiences.",
    img: Wanderly,
    dribble: "https://dribbble.com/shots/26845597-Wanderly-Explore-the-world",
    liveLink:
      "https://www.figma.com/design/wqO9EDvMr6psrdOPxegUXz/Wanderly?node-id=0-1&t=FsErXwRavrt6u0xn-1",
  },

  {
    id: 16,
    title: "Decoor",
    category: "uiux",
    description:
      "Decoor is Home decoration services provider and products selling website. Its provide both services and products..",
    img: Decoor,
    dribble:
      "https://dribbble.com/shots/26724684-Decoor-Redefine-Your-Space-with-Modern-Minimalist",
    liveLink:
      "https://www.figma.com/design/WIUqsMIJRXBkuloqURCOuV/Decoor?node-id=19-371&t=l7HyOouLkyiRR5TP-1",
  },
  {
    id: 19,
    title: "Infra Interior",
    category: "uiux",
    description:
      "Infra is a minimalist interior design landing page designed with a clean and simple approach. Every section is built with purpose, from generous spacing to soft tones and readable typography.",
    img: Infra,
    dribble: "https://dribbble.com/shots/26844937-Infra-Interior",
    liveLink:
      "https://www.figma.com/design/RkL8JiNDZ8qeYlxTetvCMk/Infra-Interior-Design?node-id=0-1&t=FsErXwRavrt6u0xn-1",
  },
  {
    id: 14,
    title: "Nastech",
    category: "uiux",
    description:
      "Landing page design for Nastech, a Software Company, providing Software & Digital solution. The main goal was to transform their complex service offerings into a simple clear, trustworthy, and conversion-focused experience. ",
    img: Nastech,
    dribble:
      "https://dribbble.com/shots/26721592-Software-Company-Homepage-UI-Design",
    liveLink:
      "https://www.figma.com/design/FsFLYf97AsfapKh75TDhMc/Nastech--Software-agency?t=yCqKJE0b5UsOwH0I-1",
  },
  {
    id: 18,
    title: "Solar",
    category: "uiux",
    description:
      "Solar is a modern and minimal solar energy landing page- to highlight clean energy solutions in a visually warm and trustworthy way.",
    img: Solar,
    dribble: "https://dribbble.com/shots/26849038-Soltra-Your-energy",
    liveLink:
      "https://www.figma.com/design/e8rOz4JfybjRZDPOpafUjd/Soltra?node-id=0-1&t=dyMjDFoWJmQJJGKN-1",
  },
  {
    id: 3,
    title: "Green Planet",
    category: "uiux",
    description:
      "Green Planet is an environmental conservation app that promotes eco-friendly practices and...",
    img: ProGreeplanet,
    dribble:
      "https://dribbble.com/shots/26721329-UI-Designing-for-a-Healthier-Earth",
    liveLink:
      "https://www.figma.com/design/Rf8FXpjuaEFsNHPi7VrWz7/Green-Planet?t=Xtq2lL8y13XaifqA-1",
  },
  {
    id: 3,
    title: "SocioMeet",
    category: "uiux",
    description:
      "SocioMeet is future social media for next generation; design for a more connected and meaningful online experience...",
    img: SocioMeet,
    // dribble:
    //   "https://dribbble.com/shots/26721329-UI-Designing-for-a-Healthier-Earth",
    liveLink:
      "https://www.figma.com/design/brFj1CLqwJ6boSZZnwXcsA/SocioMeet--Social-Platform?node-id=0-1&t=Op9KvEuCC9it2cD9-1",
  },
  {
    id: 4,
    title: "JII",
    category: "uiux",
    description:
      "Jll is a SAAS language learning app that helps users learn Japanese through interactive lessons...",
    img: ProJll,
    liveLink:
      "https://www.figma.com/design/zSovSJBnVdgKfz2N0WqIyP/Jll---Language-learning?t=Xtq2lL8y13XaifqA-1",
  },
  {
    id: 5,
    title: "CholoGhuri",
    category: "uiux",
    description:
      "Tour & Travel is a travel app that allows users to explore destinations, book tours, and manage their i...",
    img: Tour,
    liveLink:
      "https://www.figma.com/design/nmSSYOSioZpRhC1UOW4OOc/Tour-app?t=Xtq2lL8y13XaifqA-1",
  },
];
